import React from "react";
import TicketChatPanel from "../TicketChat/TicketChatPanel";
import TicketMetaControls from "./TicketMetaControls";

export const TicketConversationPane = ({
  selectedTicket,
  token,
  currentUser,
  metaDraft,
  dirty,
  savingMeta,
  assigningMeta,
  assignError,
  saveMessage,
  agentOptions,
  onMetaChange,
  onAssignMeta,
  onUnassignMeta,
  onSaveMeta,
}) => {
  if (!selectedTicket) {
    return (
      <section className="workspace-right workspace-empty">
        <h3>Select a ticket</h3>
        <p>Choose a ticket from the left panel to start support chat.</p>
      </section>
    );
  }

  return (
    <section className="workspace-right">
      <TicketMetaControls
        ticket={selectedTicket}
        draft={metaDraft}
        dirty={dirty}
        saving={savingMeta}
        assigning={assigningMeta}
        assignError={assignError}
        saveMessage={saveMessage}
        agentOptions={agentOptions}
        onChange={onMetaChange}
        onAssign={onAssignMeta}
        onUnassign={onUnassignMeta}
        onSave={onSaveMeta}
      />

      <div className="workspace-chat-wrap">
        <TicketChatPanel
          ticketId={selectedTicket.id}
          companyId={selectedTicket.companyId}
          token={token}
          currentUser={currentUser}
          hideHeader
          className="workspace-chat-panel"
        />
      </div>
    </section>
  );
};

export default TicketConversationPane;
